// components/StateSelect.tsx
import React from "react";
import MasterDropdown from "../common/MasterDropdown";
import type { MasterOption } from "../common/MasterDropdown";

// Static state options (no API)
const STATE_OPTIONS: MasterOption[] = [
  { value: "Maharashtra", label: "Maharashtra" },
  { value: "Karnataka", label: "Karnataka" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Delhi", label: "Delhi" },
  { value: "Tamil Nadu", label: "Tamil Nadu" },
  { value: "Telangana", label: "Telangana" },
];

interface StateSelectProps {
  value: string | number | null | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  label?: string;
  name?: string;
  disabled?: boolean;
}

const StateSelect: React.FC<StateSelectProps> = ({
  value,
  onChange,
  required = false,
  label = "State",
  name = "state",
  disabled = false,
}) => {
  const handleChange = (newValue: string | number | null) => {
    // Mimic old event structure for backward compatibility
    const fakeEvent = {
      target: {
        name,
        value: newValue || "",
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(fakeEvent);
  };

  return (
    <MasterDropdown
      options={STATE_OPTIONS}
      value={value}
      onChange={handleChange}
      loading={false}
      label={label}
      name={name}
      required={required}
      disabled={disabled}
      fullWidth
      disableClearable={false}
    />
  );
};

export default StateSelect;
